import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'careers/i18n'
import JobAdDetails from 'components/job-ad-details'
import { useNavigate } from 'react-router-dom'
import { logEvent, EVENT_ACTIONS } from 'actions/audit-trail'
import { VideoType } from 'types'

interface JobAdDetailsPageProps {
  company: { _id: string; slug: string }
  jobAd: {
    _id: string
    description: string
    video?: VideoType
    language: string
    slugs: string[]
  }
  dispatch: any
}

const mapStateToProps = (state: any) => ({
  application: state.application,
  company: state.careers.company,
  jobAd: state.jobAd,
})

/**
 * Render job ad page content
 * @param {object} jobAd
 * @param {object} openApplication funtion which will be called when apply is clicked
 * @param {object} company
 */

export function JobAdDetailsPage({
  company,
  jobAd,
  dispatch,
}: JobAdDetailsPageProps) {
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(
      logEvent({
        ec: company._id,
        ea: EVENT_ACTIONS.jobAdView,
        el: jobAd._id,
      })
    )
  }, [])

  const openApplication = () => {
    navigate(`/careers/${jobAd.language}/${company.slug}/${[
      ...jobAd.slugs,
    ].pop()}/apply`);
  }

  return (
    <JobAdDetails
      jobAd={jobAd}
      company={company}
      openApplication={openApplication}
    />
  )
}

export default connect(mapLanguageToComponentProps(mapStateToProps))(
  JobAdDetailsPage
)
